export default function (text) {
    return !text ? [] : text.split(/\r\n|\n\r|\r|\n/);
}
